import BaseInput from 'src/components/Base/Inputs/BaseInput.vue'
import BaseDropdown from 'src/components/Base/BaseDropdown.vue'
import Card from 'src/components/Base/Cards/Card.vue'
import BaseButton from 'src/components/Base/BaseButton.vue'
import { Input, InputNumber, Tooltip, Popover, Table, TableColumn, Select, Option, OptionGroup, Tag, Upload, Button} from 'element-ui'
import dragUpload from '@/components/dragUpload/index.vue'
import {BaseRadio, Modal, ImageUpload, BasePagination, BaseCheckbox, Tabs, TabPane} from 'src/components'
import VueCookies from 'vue-cookies'
import {BaseAlert} from 'src/components'
import VueNumeric from 'vue-numeric'
import VueNumericInput from 'vue-numeric-input';
import VueCurrencyInput from 'vue-currency-input'
import FullCalendar from '@fullcalendar/vue'


const pluginOptions = {
  /* see config reference */
  globalOptions: { 
  }
}

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

import VModal from 'vue-js-modal'
import 'vue-js-modal/dist/styles.css'

import Vue from 'vue'
import VxTooltip from '@/renew/layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from '@/renew/components/vx-card/VxCard.vue'
import VxList  from '@/renew/components/vx-list/VxList.vue'
import VxBreadcrumb  from '@/renew/layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from '@/renew/components/FeatherIcon.vue'
import VxInputGroup  from '@/renew/components/vx-input-group/VxInputGroup.vue'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

import Datepicker from 'vuejs-datepicker';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import FileUpload from 'vue-upload-component'
import draggable from 'vuedraggable'

// v-select component


import VueClipboard from 'vue-clipboard2'
 

// Chart
import BarChart from "@/renew/components/chart/barChart.vue"                                         // Bar Chart
import Bar_xyChart from "@/renew/components/chart/bar_xyChart.vue"                                   // Bar Standard Only X,Y Chart
import PieChart from "@/renew/components/chart/pieChart.vue"                                         // Pie Chart
import LineChart from "@/renew/components/chart/lineChart.vue"                                       // Pie Chart
import BarChartReact from "@/renew/components/chart/barChartReact.vue"                                         // Bar Chart reactive
import PieChartReact from "@/renew/components/chart/pieChartReact.vue"                                         // Pie Chart reactive
import LineChartReact from "@/renew/components/chart/lineChartReact.vue"    

import MapChart from '@/renew/components/mapChart/App.vue' 

import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'


import MultiLang from "@/renew/components/multi-lang.vue"    
import DjLang from "@/renew/components/dj-lang.vue"    
import TheCustomizer from "@/renew/layouts/components/customizer/TheCustomizer.vue"    
import DatePickerBox from "@/renew/components/datePickerBox.vue"    

import ContributorModal from "@/renew/components/contributor.vue";
import ContributorRegistrationModal from "@/renew/components/contributorRegistration.vue";
import TrackPreviewPicker from "@/renew/components/TrackPreviewPicker.vue";
import TrackFileBatchUpload from "@/renew/components/TrackFileBatchUpload.vue";


import { Chrome } from 'vue-color'
import ColorPicker from '@/renew/components/colorPicker.vue'

import editor  from '@/renew/components/editor.vue'
// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})


const GlobalComponents = {
  
  install (Vue) {

    
    Vue.use(Tooltip)
    Vue.use(Popover)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
   
    Vue.use(VueCookies)
    Vue.use(Button)
    Vue.use(OptionGroup)
    Vue.use(VueCurrencyInput, pluginOptions)
    Vue.component('file-upload',FileUpload)
    Vue.component('ag-grid-vue', AgGridVue)
    
    
    Vue.component('FullCalendar',FullCalendar)


    Vue.use(Datepicker)
    Vue.component('datepicker', Datepicker)
    Vue.component('date-picker',DatePicker)
    // disable date 커스텀 컴포넌
    Vue.component('date-picker-box',DatePickerBox)
    
    Vue.component(VxTooltip.name, VxTooltip)
    Vue.component(VxCard.name, VxCard)
    Vue.component(VxList.name, VxList)
    Vue.component(VxBreadcrumb.name, VxBreadcrumb)
    Vue.component(FeatherIcon.name, FeatherIcon)
    Vue.component(VxInputGroup.name, VxInputGroup)
    Vue.component(vSelect)
    Vue.component('v-select',vSelect)
    Vue.component(BaseInput.name, BaseInput)
    Vue.component(BaseDropdown.name, BaseDropdown)
    Vue.component(Card.name, Card)
    Vue.component(BaseCheckbox.name, BaseCheckbox)
    Vue.component(BaseButton.name, BaseButton)
    Vue.component(Input.name, Input)
    Vue.component(InputNumber.name, InputNumber)
   
    Vue.component("dragUpload", dragUpload)
    Vue.component(Modal.name, Modal)
    Vue.component(BaseAlert.name, BaseAlert)
    Vue.component(Tag.name, Tag)
    Vue.component(Upload.name, Upload)
    Vue.component(BaseRadio.name, BaseRadio)
    Vue.component(ImageUpload.name, ImageUpload)
    Vue.component(BasePagination.name, BasePagination)
    
    Vue.component(Tabs.name, Tabs)
    Vue.component(TabPane.name, TabPane)
    Vue.component('vue-numeric',VueNumeric)
    Vue.use(VueNumericInput)
    Vue.use(VModal, { componentName: 'v-modal', dynamicDefault: { draggable: true, resizable: true }  })
    Vue.component(draggable.name, draggable)
    Vue.use(VueClipboard)

    
    Vue.component('chrome-picker', Chrome)
    Vue.component('colorPicker', ColorPicker)
    
   
    Vue.component('editor',editor)
    Vue.component('barChart', BarChart)
    Vue.component('bar_xyChart', Bar_xyChart)
    Vue.component('pieChart', PieChart)
    Vue.component('lineChart', LineChart)
    Vue.component('barChartReact', BarChartReact)
    Vue.component('pieChartReact', PieChartReact)
    Vue.component('lineChartReact', LineChartReact)
    Vue.component('multiLang', MultiLang)
    Vue.component('djLang', DjLang)
    Vue.component('TheCustomizer', TheCustomizer)
    
    Vue.component('ContributorModal',ContributorModal)
    Vue.component('ContributorRegistrationModal',ContributorRegistrationModal)
    Vue.component('TrackPreviewPicker', TrackPreviewPicker)
    Vue.component('TrackFileBatchUpload', TrackFileBatchUpload)
        
    
    Vue.component('MapChart',MapChart)

    Vue.use(VueGoodTablePlugin);
    

  },
}

export default GlobalComponents
